import ActionTypes from "../../constants/actionTypes";

export const closeSnackBar = () => {
    return dispatch => {
      dispatch({
        type: ActionTypes.CLOSE_SNACK_BAR
      });
    };
  };